// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/graph/v1/transceiver.proto (package mochabugapis.adapt.graph.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { SignalDescriptor, SignalDescriptorJson } from "./signal_descriptor_pb";
import { file_mochabugapis_adapt_graph_v1_signal_descriptor } from "./signal_descriptor_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/graph/v1/transceiver.proto.
 */
export const file_mochabugapis_adapt_graph_v1_transceiver: GenFile = /*@__PURE__*/
  fileDesc("Ci1tb2NoYWJ1Z2FwaXMvYWRhcHQvZ3JhcGgvdjEvdHJhbnNjZWl2ZXIucHJvdG8SG21vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC52MSLRAgoLVHJhbnNjZWl2ZXISMwoEbmFtZRgBIAEoCUIlukgiciAQARgyMhpeW18kYS16QS1aXVtfJGEtekEtWjAtOV0qJBIcCgVsYWJlbBgCIAEoCUIIukgFcgMY+gFIAIgBARIiCgtkZXNjcmlwdGlvbhgDIAEoCUIIukgFcgMY6AdIAYgBARKwAQoHc2lnbmFscxgEIAMoCzItLm1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC52MS5TaWduYWxEZXNjcmlwdG9yQnC6SG26AWQKFHNpZ25hbHNfdW5pcXVlX25hbWVzEiRFYWNoIHNpZ25hbCBtdXN0IGhhdmUgYSB1bmlxdWUgbmFtZS4aJnRoaXMubWFwKHNpZ25hbCwgc2lnbmFsLm5hbWUpLnVuaXF1ZSgpkgEDEIAEQggKBl9sYWJlbEIOCgxfZGVzY3JpcHRpb25iBnByb3RvMw", [file_buf_validate_validate, file_mochabugapis_adapt_graph_v1_signal_descriptor]);

/**
 * Transceiver declares a mode-less signal endpoint. It is used for graph
 * boundaries whose transmission semantics are fixed by context, such as start
 * vertex transmitters and exchange receivers.
 *
 * @generated from message mochabugapis.adapt.graph.v1.Transceiver
 */
export type Transceiver = Message<"mochabugapis.adapt.graph.v1.Transceiver"> & {
  /**
   * Identifier for the transceiver, following the ECMA naming pattern, limited to 50 characters.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Optional human-readable label for the transceiver, up to 250 characters.
   *
   * @generated from field: optional string label = 2;
   */
  label?: string | undefined;

  /**
   * Optional descriptive text for the transceiver's purpose, up to 1000 characters.
   *
   * @generated from field: optional string description = 3;
   */
  description?: string | undefined;

  /**
   * List of signals this transceiver declares. Can contain up to 512 unique signals.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.SignalDescriptor signals = 4;
   */
  signals: SignalDescriptor[];
};

/**
 * Transceiver declares a mode-less signal endpoint. It is used for graph
 * boundaries whose transmission semantics are fixed by context, such as start
 * vertex transmitters and exchange receivers.
 *
 * @generated from message mochabugapis.adapt.graph.v1.Transceiver
 */
export type TransceiverJson = {
  /**
   * Identifier for the transceiver, following the ECMA naming pattern, limited to 50 characters.
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * Optional human-readable label for the transceiver, up to 250 characters.
   *
   * @generated from field: optional string label = 2;
   */
  label?: string;

  /**
   * Optional descriptive text for the transceiver's purpose, up to 1000 characters.
   *
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * List of signals this transceiver declares. Can contain up to 512 unique signals.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.SignalDescriptor signals = 4;
   */
  signals?: SignalDescriptorJson[];
};

/**
 * Describes the message mochabugapis.adapt.graph.v1.Transceiver.
 * Use `create(TransceiverSchema)` to create a new message.
 */
export const TransceiverSchema: GenMessage<Transceiver, {jsonType: TransceiverJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_v1_transceiver, 0);

